module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "build-content middle-block js-pipeline-graph"
  }, [_c('div', {
    staticClass: "pipeline-visualization pipeline-graph"
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "loading-icon fa fa-spin fa-spinner fa-3x",
    attrs: {
      "aria-label": "Loading",
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('ul', {
    staticClass: "stage-column-list"
  }, _vm._l((_vm.state.graph), function(stage, index) {
    return _c('stage-column-component', {
      key: stage.name,
      attrs: {
        "title": _vm.capitalizeStageName(stage.name),
        "jobs": stage.groups,
        "stage-connector-class": _vm.stageConnectorClass(index, stage),
        "is-first-column": _vm.isFirstColumn(index)
      }
    })
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/~/vue-loader/lib/template-compiler?{"id":"data-v-26bda227"}!/home/git/gitlab/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/graph_component.vue
// module id = GJO7
// module chunks = 6